export default "__VITE_ASSET__Q4itTr4M__"